import {
  biggerOrTo,
  dealwithChannel,
  translateInfluencer,
} from '../../render-helper';

export default [
  {
    header: 'Channel',
    render: 'channel',
    renderHelper: [dealwithChannel],
  },
  {
    header: 'Influencer Tier',
    render: 'name',
    renderHelper: [translateInfluencer],
  },
  {
    header: 'Counts',
    render: 'value',
    numFmt: '#,##',
    renderHelper: [biggerOrTo(0, '')],
  },
];
